import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { enumUtil } from "../../../utils/Enum";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import NotificationHandler from "../../../utils/NotificationHandler";
import Loader from "../Loader/Loader";
import { EmploymentStatus, GenderDemographic, GenderIdentity, MaritalStatus } from "../../../utils/Constants";
import DropdownValueHandler from "../SuperSearch/DropdownValueHandler";
import FormatPhoneNumber from "../../../utils/FormatPhoneNumber";
import { formatFax } from "../../../utils/Formatting";

const MergeDemographicsForm = ({ mergeInfoForm, onClose, ID }) => {
    const [isLoading, setIsLoading] = useState(false)
    const API_URL = enumUtil.controller.Patient
    const GENERAL_API_URL = enumUtil.controller.General || "General"
    const [Data, setData] = useState(null)

    const LoadData = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/GetPatientIntakeformData", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeTemplateData,
            "ID": ID
        }).then((response) => {
            setIsLoading(false)
            setData(response)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setData(null)
        })
    }

    useEffect(() => {
        LoadData()
    }, [])

    const ReconcileSingle = (fieldName) => {
        if (!Data) return

        const fieldMapping = {
            'LastName': 'LastName',
            'FirstName': 'FirstName',
            'PreferredName': 'PreferredName',
            'SSN': 'SSN',
            'DOB': 'DOB',
            'AddressLine1': 'AddressLine1',
            'AddressLine2': 'AddressLine2',
            'City': 'City',
            'State': 'State',
            'ZipCode': 'ZipCode',
            'MobileNumber': 'MobileNumber',
            'HomePhoneNumber': 'HomePhoneNumber',
            'WorkNumber': 'WorkNumber',
            'OtherPhone': 'OtherPhone',
            'Gender': 'Gender',
            'GenderIdentity': 'GenderIdentity',
            'Race': 'Race',
            'Ethnicity': 'Ethnicity',
            'MaritalStatus': 'MaritalStatus',
            'EmploymentStatus': 'EmploymentStatus',
            'PreferredLanguage': 'PreferredLanguage'
        }

        const apiFieldName = fieldMapping[fieldName]
        if (!apiFieldName) return

        let requestData = {
            "TableName": "PatientIntakeTemplateData",
            "ID": Data.PatientID.toString(),
            "data": {}
        }
        if (fieldName === 'City') {
            requestData.data = {
                'City': Data['City'] || '',
                'State': Data['State'] || '',
                'ZipCode': Data['ZipCode'] || ''
            }
        } else if (fieldName === 'LastName') {
            requestData.data = {
                'LastName': Data['LastName'] || '',
                'FirstName': Data['FirstName'] || ''
            }
        } else if(fieldName === 'AddressLine1'){
             requestData.data = {
                'AddressLine1': Data['AddressLine1'] || '',
                'AddressLine2': Data['AddressLine2'] || ''
            }

        } else {
            requestData.data[apiFieldName] = Data[fieldName] || ''
        }
        // requestData.data['PatientIntakeFormID'] = Data.PatientIntakeFormID + "";

        setIsLoading(true)
        ServerRequestProtected(GENERAL_API_URL + "/SaveSingleRecord", 'post', requestData)
            .then((response) => {
                setIsLoading(false)
                LoadData()
                NotificationHandler("Field updated successfully", enumUtil.enumtoaster.success)

                // Reload data to get latest patient data
            })
            .catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response?.data || "Error updating field", enumUtil.enumtoaster.error)
            })
    }
    const ReconcileAll = () => {
        if (!Data) return

        const fieldMappings = {
            'LastName': 'LastName',
            'FirstName': 'FirstName',
            'PreferredName': 'PreferredName',
            'SSN': 'SSN',
            'DOB': 'DOB',
            'AddressLine1': 'AddressLine1',
            'City': 'City',
            'State': 'State',
            'ZipCode': 'ZipCode',
            'MobileNumber': 'MobileNumber',
            'HomePhoneNumber': 'HomePhoneNumber',
            'WorkNumber': 'WorkNumber',
            'OtherPhone': 'OtherPhone',
            'Gender': 'Gender',
            'GenderIdentity': 'GenderIdentity',
            'Race': 'Race',
            'Ethnicity': 'Ethnicity',
            'MaritalStatus': 'MaritalStatus',
            'EmploymentStatus': 'EmploymentStatus',
            'PreferredLanguage': 'PreferredLanguage'
        }

        const requestData = {
            "TableName": "PatientIntakeTemplateData",
            "ID": Data.PatientID.toString(),
            "data": {}
        }

        // Add only fields that have changes (Identifier is true)
        Object.keys(fieldMappings).forEach(field => {
            const identifierField = field + 'Identifier'
            if (Data[identifierField] === 'true') {
                const apiField = fieldMappings[field]
                requestData.data[apiField] = Data[field]
            }
        })

        // Check if there are any fields to update
        if (Object.keys(requestData.data).length === 0) {
            NotificationHandler("No fields to reconcile", enumUtil.enumtoaster.error)
            return
        }
        setIsLoading(true)
        ServerRequestProtected(GENERAL_API_URL + "/SaveSingleRecord", 'post', {
            "TableName": "PatientIntakeTemplateData",
            "ID": Data.PatientID.toString(),
            "data": {
                ReconcileAll: 'true',
                PatientIntakeFormID: Data.PatientIntakeFormID + ""
            }
        })
            .then((response) => {
                setIsLoading(false)
                NotificationHandler("All fields reconciled successfully", enumUtil.enumtoaster.success)

                // Update all identifiers to false in local state
                // const updatedData = { ...Data }
                // Object.keys(fieldMappings).forEach(field => {
                //     const identifierField = field + 'Identifier'
                //     updatedData[identifierField] = 'false'
                // })
                // setData(updatedData)

                // Reload data to get latest patient data
                LoadData()
            })
            .catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response?.data || "Error reconciling fields", enumUtil.enumtoaster.error)
            })
    }
    const MarkAsProcessed = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/UpdateIntakeStatus", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "ID": ID,
            "Data": {
                "IntakeStatus": "Processed"
            }
        }).then((response) => {
            setIsLoading(false)
            setData(response)
            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            onClose()
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response?.data, enumUtil.enumtoaster.error)
        })
    }
    return (
        <Modal show={mergeInfoForm} onHide={mergeInfoForm} backdrop="static" keyboard={false} centered dialogClassName="ar_merg-info-form-popup">
            {isLoading ? <Loader /> : null}
            <Modal.Body>
                <div className="d-flex align-items-center justify-content-center gap-2 mb-12">
                    <i className="icon-Icon-metro-cross fs-20" onClick={onClose}></i>
                </div>
                <div className="ar_native_pdf_design">
                    <div className='d-flex flex-column gap-10'>
                        <div className="d-flex align-items-center justify-content-between pb-1-5 br-bottom-1 za_br_light">
                            <p className="text fs-11 ar-light-color">Submitted on {Data?.SubmittedDate}</p>
                            <div className="d-flex align-items-center gap-6">
                                {Data?.Status === 'Processed' ? null :
                                    <p className="text validate-color font-m pe-1-5 br-right-1 br-clr-light cursor-pointer" onClick={MarkAsProcessed}>Mark As Processed</p>
                                }
                                {Data?.TrueIdentifierCount > 0 ?
                                    <p className="text validate-color font-m cursor-pointer" onClick={ReconcileAll}>Reconcile All</p>
                                    : null}
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center pat-det-header">
                            <p className="heading text-white">Patient Demographics</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="">
                                <img src={Data?.PracticeImage} alt="" style={{ maxHeight: '60px' }} crossOrigin="anonymous" />
                            </div>
                            <div className="text-center">
                                <p className='heading validate-color fs-14'>{Data?.PracticeName}</p>

                                <p className="text text-black">
                                    {Data?.PracticeAddress} <br />
                                    {Data?.PracticeCity || ''}
                                    {Data?.PracticeCity && Data?.PracticeState ? ', ' : ''}
                                    {Data?.PracticeState || ''}
                                    {Data?.PracticeState && Data?.PracticeZipCode ? ', ' : ''}
                                    {Data?.PracticeZipCode || ''}
                                </p>

                            </div>
                            <div className="d-flex gap-10">
                                <div className="">
                                    <p className='text text-black font-m pb-2px'>Tel:</p>
                                    <p className='text text-black font-m'>Fax:</p>
                                </div>
                                <div className="">
                                    <p className='text text-black  pb-2px'>{FormatPhoneNumber(Data?.PracticeTelephone)}</p>
                                    <p className='text text-black '>{formatFax(Data?.PracticeFax)}</p>
                                </div>
                            </div>
                        </div>

                        {Data?.TrueIdentifierCount > 0 ?
                            <div className='ar-alert d-flex align-items-center gap-1 m-0'>
                                <i className='icon-alert'></i>
                                <p className='text'>There are {Data?.TrueIdentifierCount} fields that you didn't merge. Use the arrow icons or the <span className="heading cursor-pointer" onClick={ReconcileAll}>Reconcile All</span> option above to update the information.</p>
                            </div>
                            : null}

                        <div className="d-flex gap-10 scroll-content hover-scrollbar">
                            <div className="submited-form-content p-2 w-50 h-100">
                                <p className="heading fs-15 text-decoration-underline text-black pb-1-5">Submitted Form</p>
                                <div className="d-flex flex-column gap-16">
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Name</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">
                                                {Data?.LastName || ''}
                                                {Data?.LastName && Data?.FirstName ? ', ' : ''}
                                                {Data?.FirstName || ''}
                                            </p>
                                            {Data?.LastNameIdentifier === 'true' || Data?.FirstNameIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('LastName')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Preferred Name</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.PreferredName || ''}</p>
                                            {Data?.PreferredNameIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('PreferredName')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>SSN</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.SSN || ''}</p>
                                            {Data?.SSNIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('SSN')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Date of Birth</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.DOB || ''}</p>
                                            {Data?.DOBIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('DOB')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Address</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.AddressLine1 || ''}{Data?.AddressLine2 ? ` ${Data?.AddressLine2}` : ''}</p>
                                            {Data?.AddressIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('AddressLine1')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>City/State/ZIP</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">
                                                {/* {Data?.City} <br /> */}
                                                {Data?.City || ''}
                                                {Data?.City && Data?.State ? ', ' : ''}
                                                {Data?.State || ''}
                                                {Data?.State && Data?.ZipCode ? ', ' : ''}
                                                {Data?.ZipCode || ''}
                                            </p>
                                            {Data?.CityIdentifier === 'true' || Data?.StateIdentifier === 'true' || Data?.ZipCodeIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('City')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Cell Phone</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.MobileNumber || ''}</p>
                                            {Data?.CellPhoneIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('MobileNumber')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Home Phone</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.HomePhoneNumber || ''} </p>
                                            {Data?.HomePhoneNumberIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('HomePhoneNumber')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Work Phone</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.WorkNumber || ''}</p>
                                            {Data?.WorkPhoneIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('WorkNumber')}></i> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Other Phone</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.OtherPhone || ''} </p>
                                            {Data?.OtherPhoneIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('OtherPhone')}></i> : null
                                            }
                                        </div>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Sex</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{DropdownValueHandler(GenderDemographic, Data?.Gender)} </p>
                                            {Data?.SexIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('Gender')}></i> : null
                                            }
                                        </div>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Gender Identity</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{DropdownValueHandler(GenderIdentity, Data?.GenderIdentity)}</p>
                                            {Data?.GenderIdentityIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('GenderIdentity')}></i> : null
                                            }
                                        </div>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Race</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.Race || ''}</p>
                                            {Data?.RaceIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('Race')}></i> : null
                                            }
                                        </div>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Ethnicity</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.Ethnicity || ''}</p>
                                            {Data?.EthnicityIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('Ethnicity')}></i> : null
                                            }
                                        </div>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Marital Status</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{DropdownValueHandler(MaritalStatus, Data?.MaritalStatus)}</p>
                                            {Data?.MaritalStatusIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('MaritalStatus')}></i> : null
                                            }
                                        </div>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Employment Status</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{DropdownValueHandler(EmploymentStatus, Data?.EmploymentStatus)}</p>
                                            {Data?.EmploymentStatusIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('EmploymentStatus')}></i> : null
                                            }
                                        </div>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Preferred Language</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text text-black fs-14 lh-14">{Data?.PreferredLanguage || ''}</p>
                                            {Data?.PreferredLanguageIdentifier === 'true' ?
                                                <i className="icon-merge-top-right fs-10 cursor-pointer" onClick={() => ReconcileSingle('PreferredLanguage')}></i> : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pateint-demograpic-content p-2 w-50 h-100">
                                <p className="heading fs-15 text-decoration-underline text-black pb-1-5">Patient Demographics</p>
                                <div className="d-flex flex-column gap-16">
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Name</p>
                                        <p className="text text-black fs-14 lh-14">
                                            {Data?.PatientLastName || ''}
                                            {Data?.PatientLastName && Data?.PatientFirstName ? ', ' : ''}
                                            {Data?.PatientFirstName || ''}
                                        </p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Preferred Name</p>
                                        <p className="text text-black fs-14 lh-14">  {Data?.PatientPreferredName || ''}</p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>SSN</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientSSN || ''}</p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Date of Birth</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientDOB || ''}</p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Address</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientAddress || ''}</p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>ZIP/City/State</p>
                                        <p className="text text-black fs-14 lh-14">
                                            {Data?.PatientCity || ''}
                                            {Data?.PatientCity && Data?.PatientState ? ', ' : ''}
                                            {Data?.PatientState || ''}
                                            {Data?.PatientState && Data?.PatientZipCode ? ', ' : ''}
                                            {Data?.PatientZipCode || ''}
                                        </p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Cell Phone</p>
                                        <p className="text text-black fs-14 lh-14">   {Data?.PatientMobileNumber || ''}</p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Home Phone</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientHomePhone || ''} </p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Work Phone</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientWorkPhone || ''}</p>
                                    </div>
                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Other Phone</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientOtherPhone || ''} </p>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Sex</p>
                                        <p className="text text-black fs-14 lh-14">{DropdownValueHandler(GenderDemographic, Data?.PatientSex)}</p>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Gender Identity</p>
                                        <p className="text text-black fs-14 lh-14">{DropdownValueHandler(GenderIdentity, Data?.PatientGenderIdentity) || ''}</p>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Race</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientRace || ''}</p>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Ethnicity</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientEthnicity || ''}</p>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Marital Status</p>
                                        <p className="text text-black fs-14 lh-14">{DropdownValueHandler(MaritalStatus, Data?.PatientMaritalStatus) || ''}</p>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Employment Status</p>
                                        <p className="text text-black fs-14 lh-14">{DropdownValueHandler(EmploymentStatus, Data?.PatientEmploymentStatus) || ''}</p>
                                    </div>

                                    <div className="d-flex gap-15 align-items-center">
                                        <p className='text fs-14 text-black min-w-150px ar-light-color text-end'>Preferred Language</p>
                                        <p className="text text-black fs-14 lh-14">{Data?.PatientPreferredLanguage || ''}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default MergeDemographicsForm